import keyMirror from 'keymirror';

export default keyMirror({
    // api constants
    USER_INFO_LOAD_SUCCESS: null,
    USER_INFO_LOAD_FAIL: null,
    USER_EDIT_SUCCESS: null,
    USER_EDIT_FAIL: null,
    PUBLISHER_RANKS_LOAD_SUCCESS: null,
    PUBLISHER_RANKS_LOAD_FAIL: null,
    PUBLISHER_CONTACT_TYPES_LOAD_SUCCESS: null,
    PUBLISHER_CONTACT_TYPES_LOAD_FAIL: null,
    PUBLISHER_TIMEZONES_LIST_LOAD_SUCCESS: null,
    PUBLISHER_TIMEZONES_LIST_LOAD_FAIL: null,
    PAYMENT_SYSTEMS_LOAD_SUCCESS: null,
    ALLOW_PAYMENT_SYSTEMS_LOAD_SUCCESS: null,
    PAYMENT_METHODS_LOAD_SUCCESS: null,
    CURRENCIES_LOAD_SUCCESS: null,
    CURRENT_CURRENCY_CONVERT_SUCCESS: null,
    CURRENCY_CURRENT_RATIOS_LOAD_SUCCESS: null,
    CURRENCY_RATIOS_START_LOADING: null,
    CURRENCY_RATIOS_LOAD_SUCCESS: null,
    PAYMENT_DETAILS_SEARCH_START_LOADING: null,
    PAYMENT_DETAILS_SEARCH_SUCCESS: null,
    PAYMENT_DETAILS_SEND_ACTIVATION_CODE_START_LOADING: null,
    PAYMENT_DETAILS_SEND_ACTIVATION_CODE_SUCCESS: null,
    PAYMENT_DETAILS_SEND_ACTIVATION_CODE_FAIL: null,
    PAYMENT_DETAILS_METHOD_START_LOADING: null,
    PAYMENT_DETAILS_METHOD_SUCCESS: null,
    PAYOUTS_SEARCH_START_LOADING: null,
    PAYOUTS_SEARCH_SUCCESS: null,
    PAYOUTS_SEARCH_ITEM_SUCCESS: null,
    ACCOUNT_ENTRIES_START_LOADING: null,
    ACCOUNT_ENTRIES_SEARCH_SUCCESS: null,
    ADVERTISERS_SEARCH_LOADING_START: null,
    ADVERTISERS_SEARCH_SUCCESS: null,
    ADVERTISERS_SEARCH_FAIL: null,
    PERIODS_SEARCH_LOADING_START: null,
    PERIODS_SEARCH_SUCCESS: null,
    PERIODS_SEARCH_FAIL: null,
    GOAL_ENTRIES_SEARCH_LOADING_START: null,
    GOAL_ENTRIES_SEARCH_SUCCESS: null,
    GOAL_ENTRIES_SEARCH_FAIL: null,
    GOAL_ACTIONS_START_LOADING: null,
    GOAL_ACTIONS_SEARCH_SUCCESS: null,
    GOAL_ACTIONS_SEARCH_FAIL: null,
    GOAL_ACTIONS_CLEAR: null,
    OFFERS_SEARCH_START_LOADING: null,
    OFFERS_SEARCH_SUCCESS: null,
    OFFERS_SEARCH_FAIL: null,
    OFFERS_CLEAR: null,
    REFERRERS_SEARCH_START_LOADING: null,
    REFERRERS_SEARCH_SUCCESS: null,
    REFERRERS_SEARCH_FAIL: null,
    REFERRERS_CLEAR: null,
    REFERRALS_SEARCH_START_LOADING: null,
    REFERRALS_SEARCH_SUCCESS: null,
    REFERRALS_SEARCH_FAIL: null,
    REFERRALS_CLEAR: null,
    OFFERS_REFERRER_SEARCH_START_LOADING: null,
    OFFERS_REFERRER_SEARCH_SUCCESS: null,
    OFFERS_REFERRER_SEARCH_FAIL: null,
    OFFERS_REFERRER_CLEAR: null,
    ADVERTISERS_REFERRER_SEARCH_START_LOADING: null,
    ADVERTISERS_REFERRER_SEARCH_SUCCESS: null,
    ADVERTISERS_REFERRER_SEARCH_FAIL: null,
    ADVERTISERS_REFERRER_CLEAR: null,
    UTMS_SEARCH_START_LOADING: null,
    UTMS_SEARCH_SUCCESS: null,
    UTMS_SEARCH_FAIL: null,
    UTMS_CLEAR: null,
    REACTIVATION_SEARCH_START_LOADING: null,
    REACTIVATION_SEARCH_SUCCESS: null,
    REACTIVATION_SEARCH_FAIL: null,
    REACTIVATION_CLEAR: null,
    LINKS_START_LOADING: null,
    LINKS_SEARCH_SUCCESS: null,
    LINKS_FAIL: null,
    BANNERS_SEARCH_START_LOADING: null,
    BANNERS_SEARCH_SUCCESS: null,
    BANNERS_FAIL: null,
    BANNERS_LOCALES_SUCCESS: null,
    BANNERS_DIMENSIONS_SUCCESS: null,
    BANNERS_MIME_TYPES_SUCCESS: null,
    LANDINGS_SEARCH_START_LOADING: null,
    LANDINGS_SEARCH_SUCCESS: null,
    LANDINGS_FAIL: null,
    LANDINGS_HOSTING_TYPES_SUCCESS: null,
    CONTAINERS_SEARCH_START_LOADING: null,
    CONTAINERS_SEARCH_SUCCESS: null,
    CONTAINERS_FAIL: null,
    CONTAINERS_LOCALES_SUCCESS: null,
    GOALS_SEARCH_START_LOADING: null,
    GOALS_SEARCH_SUCCESS: null,
    GOALS_CLEAR: null,
    REGIONS_START_LOADING: null,
    REGIONS_SEARCH_SUCCESS: null,
    REGIONS_SEARCH_FAIL: null,
    POSTBACK_PARAMETERS_START_LOADING: null,
    POSTBACK_PARAMETERS_LOAD_SUCCESS: null,
    POSTBACK_PARAMETERS_FAIL: null,
    POSTBACK_SAVE_START_LOADING: null,
    POSTBACK_SAVE_SUCCESS: null,
    POSTBACK_EDIT_SUCCESS: null,
    POSTBACK_SAVE_FAIL: null,
    POSTBACK_CLEAR_ERROR: null,
    POSTBACK_RESET_STATE: null,
    POSTBACK_SEARCH_START_LOADING: null,
    POSTBACK_SEARCH_LOAD_SUCCESS: null,
    POSTBACK_SEARCH_START_FAIL: null,
    POSTBACK_TEST_MODAL_VISIBLE: null,
    POSTBACK_TEST_MODAL_HIDDEN: null,
    POSTBACK_TEST_START_LOADING: null,
    POSTBACK_TEST_SUCCESS: null,
    POSTBACK_TEST_FAIL: null,
    POSTBACK_TEST_CLEAR: null,
    POSTBACK_HISTORY_START_LOADING: null,
    POSTBACK_HISTORY_SUCCESS: null,
    POSTBACK_HISTORY_FAIL: null,
    DASHBOARD_LAST_START_LOADING: null,
    DASHBOARD_LAST_SUCCESS: null,
    DASHBOARD_LAST_FAIL: null,
    DASHBOARD_TODAY_START_LOADING: null,
    DASHBOARD_TODAY_SUCCESS: null,
    DASHBOARD_TODAY_FAIL: null,
    DASHBOARD_CLEAR: null,
    STATISTICS_SEARCH_START_LOADING: null,
    STATISTICS_SEARCH_SUCCESS: null,
    STATISTICS_SEARCH_FAIL: null,
    STATISTICS_SEARCH_CHART_START_LOADING: null,
    STATISTICS_SEARCH_CHART_SUCCESS: null,
    STATISTICS_SEARCH_CHART_FAIL: null,
    STATISTICS_CHART_CLEAR: null,
    CONVERSION_SEARCH_START_LOADING: null,
    CONVERSION_SEARCH_SUCCESS: null,
    CONVERSION_SEARCH_ITEM_SUCCESS: null,
    CONVERSION_GET_TOTAL_LOADING: null,
    CONVERSION_GET_TOTAL_SUCCESS: null,
    FINANCE_OPERATION_SEARCH_START_LOADING: null,
    FINANCE_OPERATION_SEARCH_SUCCESS: null,
    FINANCE_OPERATION_SEARCH_ITEM_SUCCESS: null,
    SERVER_STORAGE_START_LOADING: null,
    SERVER_STORAGE_SUCCESS: null,
    SERVER_STORAGE_FAIL: null,
    SELECT_GOAL_ACTIONS_START_LOADING: null,
    SELECT_GOAL_ACTIONS_SUCCESS: null,
    SELECT_GOAL_ACTIONS_FAIL: null,
    NOTIFICATION_START_LOADING: null,
    NOTIFICATION_SUCCESS: null,
    NOTIFICATION_FAIL: null,
    NOTIFICATION_CLOSE: null,
    NOTIFICATION_CLOSE_SUCCESS: null,
    IS_NAV_EXTENDED: null,

    AGGREGATION_INFO_START_LOADING: null,
    AGGREGATION_INFO_SUCCESS: null,
    AGGREGATION_INFO_FAIL: null,
    AGGREGATION_INFO_CLOSE: null,
    AGGREGATION_INFO_CLOSE_SUCCESS: null,

    CONVERSION_USER_INFO_START_LOADING: null,
    CONVERSION_USER_INFO_SUCCESS: null,
    CONVERSION_USER_INFO_FAIL: null,
    CONVERSION_USER_INFO_CLOSE: null,
    CONVERSION_USER_INFO_CLOSE_SUCCESS: null,

    // non request constants
    ROLE_PUBLISHER: null,
    ROLE_QA: null,
    ROLE_ADMIN: null,
    ROLE_SUPER_ADMIN: null,
    ROLE_AFFILIATE_MANAGER: null,
    ROLE_SUPPORT: null,
    ROLE_FINANCIER: null,
    ROLE_ADVERTISER: null,

    // controllers
    DYNAMIC_SEGMENT_SEARCH_START: null,
    DYNAMIC_SEGMENT_SUCCESS: null,
    DYNAMIC_SEGMENT_FAIL: null,

    // pace progress
    PACE_PROGRESS_ACTIVE: null,
    PACE_PROGRESS_TOTAL_INCREMENT: null,
    PACE_PROGRESS_UPLOADED_INCREMENT: null,
    PACE_PROGRESS_CLEAR: null,

    INFO_DOCS_LOADING_START: null,
    INFO_DOCS_LOADING_FAIL: null,
    INFO_DOCS_SET: null
});
